import { configMerge } from './config-merge.js'
import './index.scss'
export default {
    name: 'form-generator',
    props: {
        model: {
            type: [Object, Array],
            default: () => { return {} }
        },
        formConfig: {
            type: Array,
            default: () => { return [] }
        },
        rules: {
            type: Object,
            default: () => { return {} }
        },
        mode: {
            type: String,
            default: ''
        }
    },
    methods: {
        createrule(form) {
            let obj = {}
            form.map(item => {
                if (item.rule) { obj[item.key] = item.rule }
            })
            return Object.assign({}, obj, this.rules)
        },
        async validate() {
            return new Promise(async (res, rej) => {
                let result = []
                for (let item of this.formConfig) {
                    if (item.group && item.group.length) {
                        let valid = await this.$refs[item.key].validate()
                        result.push(valid)
                    }
                }
                this.$refs['form'].validate((valid) => {
                    result.push(valid)
                })
                res(!result.some(item => { return !item }))
            })
        }

    },
    render(h) {
        let formitem = []
        const getAttr = (key) => {
            return {
                on: {
                    change: (item) => {
                        this.$emit('change', { item, key })
                    }
                }
            }
        }
        const getCodeSearchAttr = (key) => {
            return {
                on: {
                    change: (item) => {
                        for (let i in item) {
                            this.$set(this.model, i, item[i])
                        }
                        this.$emit('change', { item, key })
                    }
                }
            }
        }
        let config = {
            radio: (item) => {
                let group = []
                if (item.list) {
                    for (let listitem of item.list) {
                        group.push(
                            (<el-radio label={listitem.value}>{listitem.text}</el-radio>)
                        )
                    }
                }
                return (
                    <el-radio-group disabled={item.disabled} v-model={this.model[item.key]} placeholder="请选择">
                        {group}
                    </el-radio-group>
                )
            },
            input: (item) => {
                return (<el-input disabled={item.disabled} v-model={this.model[item.key]} placeholder="请输入"></el-input>)
            },
            textarea: (item) => {
                return (<el-input disabled={item.disabled} type="textarea" v-model={this.model[item.key]} placeholder="请输入"></el-input>)
            },
            checkbox: (item) => {
                let group = []
                if (item.list) {
                    for (let listitem of item.list) {
                        group.push(
                            (<wz-checkbox label={listitem.text} v-model={listitem.value} name={item.key}></wz-checkbox>)
                        )
                    }
                }
                return (
                    <wz-checkbox-group disabled={item.disabled} v-model={this.model[item.key]} placeholder="请选择">
                        {group}
                    </wz-checkbox-group>
                )
            },
            select: (item) => {
                let group = []
                if (item.list) {
                    for (let listitem of item.list) {
                        group.push(
                            (<el-option label={listitem.text} value={listitem.value}></el-option>)
                        )
                    }
                }
                return (
                    <el-select clearable disabled={item.disabled} v-model={this.model[item.key]} placeholder="请选择" {...getAttr(item.key)}>
                        {group}
                    </el-select>
                )
            },
            date: (item) => {
                const attr = (key) => {
                    return {
                        on: {
                            change: (item) => {
                                let model = Object.assign({}, this.model, { [key]: item })
                                this.$emit('update:model', model)
                                this.$emit('change', { item, key })
                            }
                        }
                    }
                }
                return (<el-date-picker disabled={item.disabled} v-model={this.model[item.key]} placeholder="请选择" {...attr(item.key)} value-format="yyyy-MM-dd"></el-date-picker>)
            },
            number: (item) => {
                return (<el-input disabled={item.disabled} v-model={this.model[item.key]} placeholder="请输入" {...getAttr(item.key)}></el-input>)
            },
            money: (item) => {
                return (<el-input disabled={item.disabled} v-model={this.model[item.key]} placeholder="请输入" {...getAttr(item.key)}></el-input>)
            },
            point: (item) =>{
                return (<el-input disabled={item.disabled} v-model={this.model[item.key]} placeholder="提成点数" {...getAttr(item.key)}></el-input>)
            },
            upload: (item) => {
                item.options.fileList.map(file => {
                    file.id = file.file_id
                    file.name = file.file_name
                    file.status = 'success'
                })
                const attr = {
                    on: {
                        del: (id) => {
                            this.$emit('del', item.key, id)
                        }
                    }
                }
                return (<qn-upload
                    class="upload-demo"
                    drag
                    multiple
                    v-model={this.model[item.key]}
                    fileList={item.options.fileList}
                    {...attr}>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </qn-upload>)
            },
        }
        let formConfig = configMerge(this.formConfig)
        formConfig.map((item, i) => {
            if (item.type !== undefined) {
                let itemDetail = Object.assign({}, this.formConfig[i])
                let opt = (
                    <div class="wz-edit-opt">
                        <el-button-group>
                            <el-button on={{ click: () => { this.$emit('edit', { item: itemDetail, i }) } }}  plain size="mini" icon="el-icon-edit"></el-button>
                            <el-button on={{ click: () => { this.$emit('del', { item: itemDetail, i }) } }}  plain size="mini" icon="el-icon-delete"></el-button>
                            <el-button on={{ click: () => { this.$emit('move', { item: itemDetail, i }) } }} plain size="mini" icon="fa fa-arrows"></el-button>
                        </el-button-group>
                    </div >
                )
                formitem.push(
                    (
                        <el-form-item
                            label={item.type !== 'upload' ? item.label : ''}
                            prop={item.group && item.group.length ? '' : item.key}
                            class={["wz-form-item", item.options.is_full ? "full" : '', item.type === 'radio' ? 'radio' : "", this.mode === 'edit' ? 'edit' : '']}
                        >
                            {config[item.type](item, i)}
                            {this.mode === 'edit' ? opt : ''}
                        </el-form-item>
                    )
                )
            }

        })
        let rules = this.createrule(formConfig)
        return (
            <el-form
                ref="form"
                props={{
                    model: this.model,
                    rules: rules,
                    "validate-on-rule-change": false
                }}
                class="wz-form-generate">
                {formitem}
            </el-form>
        )
    }
}
